import { createAction } from '@reduxjs/toolkit';

import { GeoLocationState } from './reducer';

export const setGeoLocationStatus = createAction<GeoLocationState>('geolocation/set-status');
